import { render, staticRenderFns } from "./sticky-header.vue?vue&type=template&id=a0dd2a4c&"
import script from "./sticky-header.vue?vue&type=script&lang=js&"
export * from "./sticky-header.vue?vue&type=script&lang=js&"
import style0 from "./sticky-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default})
